import wrapperMap from '../helpers/wrapper-map';

const isWrapperRegistered = (wrapperId) => Boolean(wrapperMap.getWrapperById(wrapperId));

export default isWrapperRegistered;
